import React, { useEffect, useState } from "react";
import ProductList from "../../components/AdvanceDynamicList/ProductList";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";
import { hasPermission } from "../../pages/Login/authUtils";

const BillingReceipt = () => {
  const data = getStoredData()?.[1] || {};
  const AdminBilling = data.AdminBilling || [];
  const RedirectAdminBilling = data.RedirectAdminBilling;
  const ApiBilling = data.ApiBilling;
  const roleCompare = data.roleCompare || [];
  const StatusBilling = data.BillingStatus || [];

  const { apiData } = useApiData(["billing"]);
  const [billingRecords, setBillingRecords] = useState([]);

  const canDelete = hasPermission("billing:delete");
  const canUpload = hasPermission("billing:upload");
  const canDownload = hasPermission("billing:download");


  useEffect(() => {
    if (Array.isArray(apiData?.billing)) {
      setBillingRecords(apiData.billing);
    }
  }, [apiData?.billing]);

  return (
    <div className="BillingReceipt">
      <ProductList
        products={billingRecords}
        setProducts={setBillingRecords}
        fields={AdminBilling}
        redirect={RedirectAdminBilling}
        deleteApi={ApiBilling}
        roleCompare={roleCompare}
        createPath={hasPermission("billing:create") ? "/billing/create" : null}
        showDelete={canDelete}
        showUpload={canUpload}
        showDownload={canDownload}
        status={StatusBilling}
        title={data.TitleBilling}
      />
    </div>
  );
};

export default BillingReceipt;
